// extracted by mini-css-extract-plugin
module.exports = {"bookingItem":"CalendarView_bookingItem__WXSmz","pending":"CalendarView_pending__bAJ_x"};